import { HEADER_HEIGHT, useMetaContext } from '../../base';
import { useGeoData } from '../../utils';
import { GeoChartHeaderColumn } from './GeoChartHeaderColumn';
import { GeoChartHeaderPictureWrapper } from './GeoChartHeaderPictureWrapper';

export const GeoChartHeader = () => {
    const meta = useMetaContext();
    const { divColumnsHeaderRef } = useGeoData();

    return (
        <div
            ref={divColumnsHeaderRef}
            style={{ height: HEADER_HEIGHT }}
            className="flex overflow-y-scroll border bg-white w-fit dark:bg-block-secondary"
        >
            {meta.columns.map(c => {
                return <GeoChartHeaderColumn column={c} key={c.key} />;
            })}
            <GeoChartHeaderPictureWrapper />
        </div>
    );
};
